<ng-container [formGroup]="optionForm">
  <div class="form-check">
    <input type="checkbox" class="form-check-input" formControlName="isSelected" id="isSelected-{{componentId}}">
    <label class="form-check-label" for="isSelected-{{componentId}}">{{option.description}}</label>
  </div>
</ng-container>
